module.exports = __webpack_public_path__ + "img/food-37.5a9016fa.jpg";